import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 40px 0 16px 0;
`

export const ContentTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 4px;
  margin-bottom: 8px;
`

export const Info = styled.div`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: #E6F8FD;

  p {
    color: var(--gray-2);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Title = styled.h1`
  color: var(--gray-2);
  font-family: var(--primary-font);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: left;
  width: calc(100% - 54px);
  word-wrap: break-word;
`

export const Content = styled.div`
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  ${({ bold }) => bold && 'font-weight: 600; text-align: center;'}
  a {
    word-break: break-all;
    word-wrap: break-word;
  }
  p {
    line-height: 150%;
  }
`

export const ContentTitle = styled.h2`
  color: var(--gray-5);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`

export const Footer = styled.footer`
  position: sticky;
  bottom: -25px;
  display: flex;
  * {
    flex: 1;
  }
  gap: 24px;
  left: 0;
  width: 100%;
  background-color: var(--the-white);
`
export const Container = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  background-color: var(--bleached-silk);
  border-radius: 99px 99px 0 99px;
  display: flex;
  align-items: center;
  justify-content: center;
`
